import chatIcon from '../assets/chrome-cast.svg'
import ClipPath from '../assets/disc-02.svg'

export const ServiceArr = [
    {
        id: 1,
        title: "Ask anything",
        desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aut accusantium animi rem sint molestiae voluptatem corporis voluptates, repudiandae ad ut!",
        icon: chatIcon
    },
    {
        id: 2,
        title: "Improve everyday",
        desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aut accusantium animi rem sint molestiae voluptatem corporis voluptates, repudiandae ad ut!",
        icon: ClipPath
    },
    {
        id: 3,
        title: "Connect anywhere",
        desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aut accusantium animi rem sint molestiae voluptatem corporis voluptates, repudiandae ad ut!",
        icon: ClipPath
    },
    {
        id: 3,
        title: "Connect anywhere",
        desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aut accusantium animi rem sint molestiae voluptatem corporis voluptates, repudiandae ad ut!",
        icon: ClipPath
    },
    {
        id: 3,
        title: "Connect anywhere",
        desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aut accusantium animi rem sint molestiae voluptatem corporis voluptates, repudiandae ad ut!",
        icon: ClipPath
    },
    {
        id: 3,
        title: "Connect anywhere",
        desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aut accusantium animi rem sint molestiae voluptatem corporis voluptates, repudiandae ad ut!",
        icon: ClipPath
    },
]

export const PaymentArr = [
    {
        id: 1,
        title: "Basic",
        desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
        price: "0",
        btntxt: "Get Started",
        line1: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
        line2: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
        color: "text-green-500"
    },
    {
        id: 2,
        title: "Premium",
        desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
        price: "9.99",
        btntxt: "Get Started",
        line1: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
        line2: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.,elit",
        line2: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.,elit",
        color: "text-purple-500"
    },
    {
        id: 3,
        title: "Enterprise",
        desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
        btntxt: "Contact us",
        line1: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
        line2: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.,elit",
        color: "text-red-500",
      
    },
]